import { j as o } from "../../jsx-runtime-B6kdoens.js";
import { c as p } from "../../index-CROKJrb5.js";
import { c as i, f as n } from "../../create-component-CBAeEoQ6.js";
import { createFooterState as f, FooterContext as d, useFooterStateAtoms as l } from "./FooterState/index.js";
import { u as x } from "../../use-sync-atom-value-CDr7vapO.js";
import { w as g } from "../../atom-provider-B3P183Tj.js";
const F = p({
  base: "cur-px-4 cur-py-8 md:cur-px-12 md:cur-py-10",
  variants: {
    mode: {
      dark: "cur-bg-surface-secondary",
      light: "cur-bg-surface-primary"
    }
  }
}), b = g(
  i(
    "Footer",
    n(
      ({ as: t, children: e, className: a, mode: r = "dark", ...s }, c) => {
        const m = t || "footer", { modeAtom: u } = l();
        return x(u, r), /* @__PURE__ */ o.jsx(
          m,
          {
            ref: c,
            className: F({ mode: r, className: a }),
            ...s,
            children: /* @__PURE__ */ o.jsx("div", { className: "cur-flex cur-flex-col cur-gap-17 md:cur-gap-20 lg:cur-gap-25", children: e })
          }
        );
      }
    )
  ),
  d,
  f
);
export {
  b as Footer
};
//# sourceMappingURL=index.js.map
